module.exports = __webpack_public_path__ + "static/media/XTZ-BNB.e8e8d0fe.svg";